document.addEventListener("turbo:load", function() {
  // File Upload Handler
  $("#js-cv-parser-file-field").on("change", function () {
    if (this.files && this.files[0]) {
      const filename = this.files[0].name;
      $("#js-cv-parser-file-container").html(`<span class="cv-parser-upload__label-text" id="file-uploaded" style="font-weight: bold; margin-bottom: 0;">${filename}</span>`);
      
      // Optional: Add styling to show file is selected
      $(".cv-parser-upload__label").css("border-color", "#66AE9B");
      $(".cv-parser-upload__label").css("background", "#e0efec");
      
      // Hide error if file is selected
      const errorList = $("#js-cv-parser-errors").find("ul");
    }
  });

  // Form Submit Handler
  $("#accepted_tos").on("click", function (e) {
    // 1. Reset Errors
    $("#js-cv-parser-errors").hide().find("ul").empty();
    
    let hasErrors = false;
    const errors = [];
    
    // 2. Validate File
    const fileInput = $("#js-cv-parser-file-field")[0];
    if (!fileInput.files || !fileInput.files[0]) {
      hasErrors = true;
      errors.push("Bitte lade deinen Lebenslauf hoch.");
    }
    
    // 3. Validate TOS
    if (!$("#js-cv-parser-tos").is(":checked")) {
      hasErrors = true;
      errors.push("Bitte akzeptiere die Datenschutzbestimmungen.");
    }
    
    // 4. Handle Errors or Submit
    if (hasErrors) {
      e.preventDefault(); // Stop Submit
      const errorList = $("#js-cv-parser-errors").find("ul");
      errors.forEach(function(error) {
        errorList.append(`<li>${error}</li>`);
      });
      $("#js-cv-parser-errors").show();
      
      // Scroll to errors
      $('html, body').animate({
        scrollTop: $("#landingpage-form").offset().top - 100
      }, 500);
      
      return false;
    }
    
    // 5. Show Spinner (only if valid)
    // Optional: Disable button to prevent double submit (after short delay to allow submit)
    setTimeout(() => {
        $(".cv-parser-upload__submit-button").prop("disabled", true).css("opacity", "0.5");
    }, 100);

    $("#spinner-cv-parser").addClass("active").html(`
      <div class="cv-parser-upload__loading">
        <i class="fas fa-spinner fa-spin cv-parser-upload__loading-spinner"></i>
        <p class="cv-parser-upload__loading-text">Deine Daten werden verarbeitet, bitte warte einen kleinen Moment.</p>
      </div>
    `);
  });
})
